import { getInitialState, getPath } from "../../utils";
import ActionTypes from "../actions/ActionTypes";
const initialState = {
  driverCashTransactionsList: [],
  prevPage: -1,
  nextPage: -1,
  currentPage: 1,
  activeFilters: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ActionTypes.SET_DRIVER_CASH_TRANSACTIONS_LIST:
      return setDriverCashTransactionsList(state, action);
    case ActionTypes.SET_ACTIVE_FILTERS_DRIVER_CASH_TRANSACTIONS:
      return setActiveFilters(state, action);
    case ActionTypes.SET_CURRENT_PAGE_DRIVER_CASH_TRANSACTIONS:
      return setCurrentPageDriverCashTransactions(state, action);
    case ActionTypes.RESET_STATE_DRIVER_CASH_TRANSACTIONS:
      return resetCurrentPageDriverCashTransactions(state, action);
    default:
      return state;
  }
}

const setDriverCashTransactionsList = (state, action) => {
  return {
    ...state,
    driverCashTransactionsList: getPath(action.payload, "data", []),
    prevPage: getPath(action.payload, "page_response.previous_page", -1),
    nextPage: getPath(action.payload, "page_response.next_page", -1),
  };
};

const setCurrentPageDriverCashTransactions = (state, action) => {
  return {
    ...state,
    currentPage: action.payload,
  };
};

const resetCurrentPageDriverCashTransactions = (state, action) => {
  // reset specific key if given else reset complete state
  if (action.payload.state) {
    return {
      ...state,
      [action.payload.state]: getInitialState(
        initialState,
        action.payload.state
      ),
    };
  } else {
    return initialState;
  }
};

const setActiveFilters = (state, action) => {
  return {
    ...state,
    activeFilters: action.payload,
  };
};
